export enum RoutesEnum {
  KPIDashboard = '/pages/kpi-dashboard',
  RevenueManager = '/pages/revenue-manager',
  Settings = '/pages/settings',
  BookingOverview = '/pages/booking-overview',
  ClusterPricing = '/pages/autopilot-configuration',
  FxRate = '/pages/fx-rate',
  SuperAdminSettings = '/pages/super-admin-settings',
  strategyPriceOverride = '/pages/bulk-change',
  PageNotFound = '/page-not-found'
}

export enum RolesEnum {
  ViewerRole = 'role-viewer',
  EditorRole = 'role-editor',
  AdminRole = 'role-admin',
  SuperAdminRole = 'role-super_admin'
}

